import React, {
  forwardRef,
  useCallback,
  useState,
  useRef,
  useEffect,
} from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { isArray, forEach, concat, isEmpty } from 'lodash';

import { t } from '~/helpers';
import { Modal } from '~/components';
import api from '~/services/api';

const AlertInvoicesDue = forwardRef((props, ref) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const modalRef = useRef(new Array());

  const {
    glousuarioorgacodigo,
    id,
    glousua_aprova_pre_faturamento,
  } = useSelector((state) => state.user.profile);

  const handleGetContestation = useCallback(async () => {
    try {
      const { data } = await api.get(
        `alarmesfaturas/contestacoesrespondidas?orga_codigo=${glousuarioorgacodigo}`
      );
      setMessages((state) => concat(state, data));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleGetApproveInvoices = useCallback(async () => {
    try {
      const { data } = await api.get(
        `alarmesfaturas/aprovarfaturas?orga_codigo=${glousuarioorgacodigo}`
      );
      setMessages((state) => concat(state, data));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const handleGetVenceInvoices = useCallback(async () => {
    try {
      const { data } = await api.get(
        `alarmesfaturas/datasavencerem?orga_codigo=${glousuarioorgacodigo}`
      );
      setMessages((state) => concat(state, data));
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(modalRef.current) && !loading) {
      forEach(modalRef.current, (element) => {
        element.handleOpenModal();
      });
    }
  }, [messages, loading]);

  return (
    <>
      {!loading &&
        messages.map((message, key) => (
          <Modal
            key={key}
            ref={(element) => modalRef.current.push(element)}
            disableBackdropClick
            disableEscapeKeyDown
            title={message.titulo}
            component={() => <p>{message.texto}</p>}
            color="#3f51b5"
            textColor="#FFF"
            actions={[
              {
                label: 'Ok',
                callback: () => modalRef.current[key].handleCloseModal(),
                variant: 'contained',
                color: 'default',
              },
            ]}
          />
        ))}
    </>
  );
});

export default AlertInvoicesDue;
